export default __webpack_public_path__ + "static/media/zip.ec23ed99.png";